// Language metadata — extracted from index.js, no translation data bundled
export interface LanguageInfo {
  code: string;
  label: string;
  nativeName: string;
}

export const LANGUAGES: LanguageInfo[] = [
  { code: 'en', label: 'English', nativeName: 'English' },
  { code: 'zh', label: 'Chinese Simplified', nativeName: '中文简体' },
  { code: 'tw', label: 'Chinese Traditional', nativeName: '中文繁體' },
  { code: 'fr', label: 'French', nativeName: 'Français' },
  { code: 'es', label: 'Spanish', nativeName: 'Español' },
  { code: 'pt', label: 'Portuguese', nativeName: 'Português' },
  { code: 'ru', label: 'Russian', nativeName: 'Русский' },
  { code: 'id', label: 'Indonesian', nativeName: 'Bahasa Indonesia' },
  { code: 'tr', label: 'Turkish', nativeName: 'Türkçe' },
  { code: 'fa', label: 'Persian', nativeName: 'فارسی' },
  { code: 'ja', label: 'Japanese', nativeName: '日本語' },
  { code: 'vi', label: 'Vietnamese', nativeName: 'Tiếng Việt' },
  { code: 'ar', label: 'Arabic', nativeName: 'العربية' },
  { code: 'ko', label: 'Korean', nativeName: '한국어' },
  { code: 'th', label: 'Thai', nativeName: 'ไทย' },
  { code: 'my', label: 'Burmese', nativeName: 'မြန်မာဘာသာ' },
  { code: 'de', label: 'German', nativeName: 'Deutsch' },
  { code: 'hi', label: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'it', label: 'Italian', nativeName: 'Italiano' },
  { code: 'nl', label: 'Dutch', nativeName: 'Nederlands' },
  { code: 'pl', label: 'Polish', nativeName: 'Polski' },
  { code: 'ms', label: 'Malay', nativeName: 'Bahasa Melayu' },
  { code: 'tl', label: 'Filipino', nativeName: 'Filipino' },
  { code: 'uk', label: 'Ukrainian', nativeName: 'Українська' },
  { code: 'ro', label: 'Romanian', nativeName: 'Română' },
  { code: 'cs', label: 'Czech', nativeName: 'Čeština' },
  { code: 'hu', label: 'Hungarian', nativeName: 'Magyar' },
  { code: 'sv', label: 'Swedish', nativeName: 'Svenska' },
  { code: 'el', label: 'Greek', nativeName: 'Ελληνικά' },
  { code: 'iw', label: 'Hebrew', nativeName: 'עברית' },
  { code: 'bn', label: 'Bengali', nativeName: 'বাংলা' },
  { code: 'bg', label: 'Bulgarian', nativeName: 'Български' },
  { code: 'da', label: 'Danish', nativeName: 'Dansk' },
  { code: 'no', label: 'Norwegian', nativeName: 'Norsk' },
  { code: 'fi', label: 'Finnish', nativeName: 'Suomi' },
  { code: 'hr', label: 'Croatian', nativeName: 'Hrvatski' },
  { code: 'sr', label: 'Serbian', nativeName: 'Srpski' },
  { code: 'sk', label: 'Slovak', nativeName: 'Slovenčina' },
  { code: 'lt', label: 'Lithuanian', nativeName: 'Lietuvių' },
  { code: 'lv', label: 'Latvian', nativeName: 'Latviešu' },
  { code: 'et', label: 'Estonian', nativeName: 'Eesti' },
  { code: 'sw', label: 'Swahili', nativeName: 'Kiswahili' },
  { code: 'ur', label: 'Urdu', nativeName: 'اُردُو' },
  { code: 'kk', label: 'Kazakh', nativeName: 'Қазақ' },
  { code: 'ka', label: 'Georgian', nativeName: 'ქართული' },
  { code: 'sl', label: 'Slovenian', nativeName: 'Slovenščina' },
  { code: 'ne', label: 'Nepali', nativeName: 'नेपाली' },
  { code: 'km', label: 'Khmer', nativeName: 'ភាសាខ្មែរ' },
  { code: 'si', label: 'Sinhala', nativeName: 'සිංහල' },
  { code: 'af', label: 'Afrikaans', nativeName: 'Afrikaans' },
  { code: 'ta', label: 'Tamil', nativeName: 'தமிழ்' },
  { code: 'te', label: 'Telugu', nativeName: 'తెలుగు' },
  { code: 'mr', label: 'Marathi', nativeName: 'मराठी' },
  { code: 'gu', label: 'Gujarati', nativeName: 'ગુજરાતી' },
  { code: 'pa', label: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ' },
  { code: 'kn', label: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  { code: 'ml', label: 'Malayalam', nativeName: 'മലയാളം' },
  { code: 'am', label: 'Amharic', nativeName: 'አማርኛ' },
  { code: 'ha', label: 'Hausa', nativeName: 'Hausa' },
  { code: 'yo', label: 'Yoruba', nativeName: 'Yorùbá' },
  { code: 'so', label: 'Somali', nativeName: 'Soomaali' },
  { code: 'zu', label: 'Zulu', nativeName: 'isiZulu' },
  { code: 'uz', label: 'Uzbek', nativeName: "O'zbek" },
  { code: 'az', label: 'Azerbaijani', nativeName: 'Azərbaycan' },
  { code: 'hy', label: 'Armenian', nativeName: 'Հայերեն' },
  { code: 'ku', label: 'Kurdish', nativeName: 'Kurdî' },
  { code: 'ps', label: 'Pashto', nativeName: 'پښتو' },
  { code: 'mn', label: 'Mongolian', nativeName: 'Монгол' },
  { code: 'lo', label: 'Lao', nativeName: 'ລາວ' },
  { code: 'mk', label: 'Macedonian', nativeName: 'Македонски' },
  { code: 'ky', label: 'Kyrgyz', nativeName: 'Кыргызча' },
  { code: 'tg', label: 'Tajik', nativeName: 'Тоҷикӣ' },
  { code: 'jv', label: 'Javanese', nativeName: 'Basa Jawa' },
  { code: 'su', label: 'Sundanese', nativeName: 'Basa Sunda' },
  { code: 'ig', label: 'Igbo', nativeName: 'Igbo' },
  { code: 'om', label: 'Oromo', nativeName: 'Afaan Oromoo' },
  { code: 'or', label: 'Odia', nativeName: 'ଓଡ଼ିଆ' },
  { code: 'ceb', label: 'Cebuano', nativeName: 'Cebuano' },
  { code: 'mg', label: 'Malagasy', nativeName: 'Malagasy' },
  { code: 'sd', label: 'Sindhi', nativeName: 'سنڌي' },
  { code: 'sq', label: 'Albanian', nativeName: 'Shqip' },
  { code: 'bs', label: 'Bosnian', nativeName: 'Bosanski' },
  { code: 'ca', label: 'Catalan', nativeName: 'Català' },
  { code: 'be', label: 'Belarusian', nativeName: 'Беларуская' },
  { code: 'tk', label: 'Turkmen', nativeName: 'Türkmen' },
  { code: 'sn', label: 'Shona', nativeName: 'chiShona' },
  { code: 'mi', label: 'Maori', nativeName: 'Māori' },
  { code: 'cy', label: 'Welsh', nativeName: 'Cymraeg' },
  { code: 'ga', label: 'Irish', nativeName: 'Gaeilge' },
  { code: 'xh', label: 'Xhosa', nativeName: 'isiXhosa' },
  { code: 'st', label: 'Sesotho', nativeName: 'Sesotho' },
  { code: 'tn', label: 'Tswana', nativeName: 'Setswana' },
  { code: 'ak', label: 'Akan', nativeName: 'Akan' },
  { code: 'ff', label: 'Fulah', nativeName: 'Fulfulde' },
  { code: 'ln', label: 'Lingala', nativeName: 'Lingála' },
  { code: 'ny', label: 'Chichewa', nativeName: 'Chichewa' },
  { code: 'rw', label: 'Kinyarwanda', nativeName: 'Kinyarwanda' },
  { code: 'ti', label: 'Tigrinya', nativeName: 'ትግርኛ' },
  { code: 'ug', label: 'Uyghur', nativeName: 'ئۇيغۇرچە' },
  { code: 'ht', label: 'Haitian Creole', nativeName: 'Kreyòl Ayisyen' },
  { code: 'gn', label: 'Guarani', nativeName: 'Avañe\'ẽ' },
  { code: 'qu', label: 'Quechua', nativeName: 'Runasimi' },
  { code: 'ilo', label: 'Ilocano', nativeName: 'Iloko' },
  { code: 'hil', label: 'Hiligaynon', nativeName: 'Hiligaynon' },
  { code: 'wo', label: 'Wolof', nativeName: 'Wolof' },
  { code: 'rn', label: 'Kirundi', nativeName: 'Ikirundi' },
];
